import { createSlice } from '@reduxjs/toolkit';

import LogRepository from '../../repositories/Admin/Memberships/LogRepository';
import { createRestSlice } from '../../utils/RestSlice';

const logsRestSlice = createRestSlice({
  resource: 'logs',
  repository: LogRepository,
  slices: ['loadLogs'],
});

const initialState = {
  ...logsRestSlice.initialState,
};

const logsSlice = createSlice({
  name: 'logs',
  initialState,
  reducers: {
    ...logsRestSlice.reducers,
  },
});

export default logsSlice.reducer;

export const logsRestHooks = logsRestSlice.hooks(logsSlice, [
  'admin',
  'LogsSlice',
]);
